import { useId } from 'react';

import { Chip } from '@mui/material';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

import styles from './TopAgentBadge.module.scss';

export type TopAgentBadgeSize = 'small' | 'medium' | 'large';

interface TopAgentBadgeProps {
  size?: TopAgentBadgeSize;
}

export const TopAgentBadge = ({ size = 'small' }: TopAgentBadgeProps) => {
  const starGradientId = `top-agent-star-${useId().replace(/:/g, '')}`;

  return (
    <Chip
      className={`${styles.badge} ${styles[size]}`}
      icon={
        <span aria-hidden='true' className={styles.starIcon}>
          <svg className={styles.gradientDefinition} focusable='false'>
            <defs>
              <linearGradient
                data-testid='top-agent-star-gradient'
                id={starGradientId}
                x1='0'
                x2='0'
                y1='0'
                y2='1'
              >
                <stop offset='0%' stopColor='#ffe45c' />
                <stop offset='100%' stopColor='#ffb800' />
              </linearGradient>
            </defs>
          </svg>
          <StarRoundedIcon
            aria-hidden='true'
            className={styles.star}
            data-testid='top-agent-star'
            style={{ fill: `url(#${starGradientId})` }}
          />
        </span>
      }
      label='TOP AGENT'
      size='small'
    />
  );
};
